import PrimaryCell from "../../../../../../ui/Table/Cells/PrimaryCell";
import StatusCell from "../../RequestRelations/RelationRequestsTable/StatusCell";
import StatusTextCell from "./StatusTextCell";

export const columns = [
  {
    dataField: "date",
    caption: "Дата",
    dataType: "date",
    cellRender: PrimaryCell,
    width: 100
  },
  {
    dataField: "status",
    caption: "Статус",
    dataType: "string",
    cellRender: StatusTextCell
  },
  {
    dataField: "name",
    caption: "Специалист",
    dataType: "string",
    cellRender: PrimaryCell
  },
  {
    dataField: "comment",
    caption: "Комментарий",
    dataType: "string",
    cellRender: PrimaryCell
  }];
